// App version metadata.
// Bump APP_VERSION_CODE every time you publish a new build to the Play Store.
// APP_VERSION_NAME is the human-readable label (semver), shown only as info.
//
// To enable the force-update gate, the admin must:
//   1. Toggle ON `force_update_enabled` in System Config.
//   2. Set `min_app_version` (versionCode integer) to the minimum allowed.
// If the current APP_VERSION_CODE is LOWER than min_app_version AND the
// client is running on Android, a blocking modal will be shown.

export const APP_VERSION_CODE = 14;
export const APP_VERSION_NAME = '2.0.1';
